import { fetchWrapper } from '@/helpers'

const ruta = process.env.VUE_APP_ROOT_API
export default class VentaService {
  async crear(datos) {
    return await fetchWrapper.post(`${ruta}/ventas`, datos)
  }

  async getAllVentas() {
    return await fetchWrapper.get(`${ruta}/ventas`)
  }
  async getVentasPaginadas(params) {
    const cleanParams = {}

    for (const key in params) {
      const value = params[key]

      if (
        value !== null &&
        value !== undefined &&
        value !== '' &&
        value !== 'null' &&
        !(typeof value === 'object' && value !== null && Object.keys(value).length === 0)
      ) {
        cleanParams[key] = value
      }
    }

    const queryString = new URLSearchParams(cleanParams).toString()
    return await fetchWrapper.get(`${ruta}/ventas/paginated?${queryString}`)
  }

  async getVenta(id) {
    return await fetchWrapper.get(`${ruta}/ventas/` + id)
  }

  async imprimirVenta(id) {
    return await fetchWrapper.getPdf(`${ruta}/venta/imprimir/${id}`)
  }
  async imprimirVentaFactura(id) {
    return await fetchWrapper.getPdf(`${ruta}/factura/imprimir/${id}`)
  }
  async filtrarVentas(datos) {
    return await fetchWrapper.post(`${ruta}/filtros_venta`, datos)
  }
  async imprimirPDF(datos) {
    return await fetchWrapper.postPdf(`${ruta}/reporte/venta/imprimir`, datos)
  }

  async imprimirRFacturasPDF(datos) {
    return await fetchWrapper.postPdf(`${ruta}/reporte_facturas`, datos)
  }
  async imprimirRFacturasElectronicasPDF(datos) {
    return await fetchWrapper.postPdf(`${ruta}/reporte_facturas_electronicas`, datos)
  }

  async imprimirRGananciasPDF(datos) {
    return await fetchWrapper.postPdf(`${ruta}/reporte_ganancias_ventas`, datos)
  }

  async exportarVentas(datos) {
    const exportado = await fetchWrapper.postWithBlob(`${ruta}/ventas-export`, datos)
    return exportado
  }
  async exportarRFacturas(datos) {
    const exportado = await fetchWrapper.postWithBlob(`${ruta}/reporte-facturas-export`, datos)
    return exportado
  }
  async exportarRFacturasElectronicas(datos) {
    const exportado = await fetchWrapper.postWithBlob(`${ruta}/reporte-facturas-electronicas-export`, datos)
    return exportado
  }
  async exportarRGananciasVentas(datos) {
    const exportado = await fetchWrapper.postWithBlob(`${ruta}/ganancias_ventas_export`, datos)
    return exportado
  }

  async filtrarGananciasVentas(datos) {
    return await fetchWrapper.post(`${ruta}/filtros_ganancias_venta`, datos)
  }

  async anularVenta(id, datos) {
    return await fetchWrapper.put(`${ruta}/ventas/anular/${id}`, datos)
  }
  updateMetodosPago(datos) {
    return fetchWrapper.post(`${ruta}/ventas/metodo_pago`, datos)
  }

  /* ====================================
	RUTAS PARA FACTURACION ELECTRONICA 
	========================================*/

  async filtros_facturas(datos) {
    return await fetchWrapper.post(`${ruta}/filtros_factura`, datos)
  }
  async exportarFacturas(datos) {
    const exportado = await fetchWrapper.postWithBlob(`${ruta}/facturas-export`, datos)
    return exportado
  }
  async imprimirPDFFacturas(datos) {
    return await fetchWrapper.postPdf(`${ruta}/reporte/factura/imprimir`, datos)
  }

  async exportarRFacturasSIN(datos) {
    const exportado = await fetchWrapper.postWithBlob(`${ruta}/reporte-facturas-sin-export`, datos)
    return exportado
  }
  async VentaGeneral(datos) {
    return await fetchWrapper.post(`${ruta}/ventas/venta_datos_necesarios`, datos)
  }
  async showFactura(id) {
    return await fetchWrapper.get(`${ruta}/showFactura/` + id)
  }
  async motivo_anulacions() {
    return await fetchWrapper.get(`${ruta}/motivo_anulacions`)
  }

  async filtros_factura_electronicas(datos) {
    return await fetchWrapper.post(`${ruta}/filtros_factura_electronica`, datos)
  }

  async imprimirVentaProforma(id) {
    return await fetchWrapper.getPdf(`${ruta}/venta/imprimir/proforma/${id}`)
  }
  async anularProforma(id) {
    return await fetchWrapper.delete(`${ruta}/proforma/anular/${id}`)
  }
  async getAllProformas(datos) {
    return await fetchWrapper.post(`${ruta}/proformas`, datos)
  }

  async getVentasPaginate(parametros) {
    const queryParams = parametros
      ? Object.keys(parametros)
          .map((k) => encodeURIComponent(k) + '=' + encodeURIComponent(parametros[k]))
          .join('&')
      : ''
    return await fetchWrapper.get(`${ruta}/ventas/listado_ventas_paginate?` + queryParams)
  }

  async buscarVentasFiltros(filtros) {
    return await fetchWrapper.post(`${ruta}/ventas/buscar_ventas_filtros`, filtros)
  }
  generarReporteVentasCreditoInteres(filtros) {
    return fetchWrapper.postPdf(`${ruta}/`, filtros)
  }

  async crear_factura(datos) {
    return await fetchWrapper.post(`${ruta}/crear_factura`, datos)
  }

  async enviarWhatsApp(datos) {
    return await fetchWrapper.post(`${ruta}/enviar_whatsapp`, datos)
  }

  async filtrarReporteMensualGestion(datos) {
    return await fetchWrapper.post(`${ruta}/filtros_reporte_mensual_gestion`, datos)
  }

  async datos_necesarios_reporte_ventas() {
    return await fetchWrapper.post(`${ruta}/ventas/datos_necesarios_reporte`)
  }

  /* async buscarProforma(id) {
    const proforma = await fetchWrapper.get(`${ruta}/proforma/${id}`);
    return proforma;
  } */
  async buscarProforma(datos) {
    const proforma = await fetchWrapper.post(`${ruta}/proforma/buscar_proforma`, datos)
    return proforma
  }
  async imprimirDirecto(id, printerName) {
    try {
      const token = localStorage.getItem('token')
      // Construimos la URL que irá al servicio Node para imprimir directamente
      const backendUrl = `${ruta}/venta/imprimir_directo/${id}`
      const url = `http://localhost:8081/print?url=${encodeURIComponent(
        backendUrl
      )}&printer=${printerName}&auth_scheme=Bearer&token=${token}`

      const response = await fetch(url, {
        method: 'GET'
      })

      if (!response.ok) {
        throw new Error('Error al imprimir')
      }
      return true
    } catch (error) {
      console.error('Error al imprimir:', error)
      throw error
    }
  }

  async verificarEstadoFactura(id) {
    try {
      const response = await fetchWrapper.get(`${ruta}/verificarEstadoFactura/${id}`)
      return response
    } catch (error) {
      if (error && error.status) {
        return error
      }
      throw error
    }
  }

  async buscarFacturaTimeout(ventaId) {
    try {
      const response = await fetchWrapper.post(`${ruta}/ventas/${ventaId}/buscar-factura-timeout`)
      return response
    } catch (error) {
      if (error && error.status) {
        return error
      }
      throw error
    }
  }
  async filtrarVentasOptimizado(datos) {
    return await fetchWrapper.post(`${ruta}/busqueda/ventas/filtros-optimizado`, datos)
  }

  async obtenerProductosVenta(ventaId) {
    return await fetchWrapper.get(`${ruta}/busqueda/ventas/${ventaId}/productos`)
  }

  async actualizarProforma(datos) {
    return await fetchWrapper.put(`${ruta}/proforma/actualizar`, datos)
  }

  async getProforma(id) {
    return await fetchWrapper.get(`${ruta}/proforma/${id}`)
  }
}
